import { firestore, updateFirebase, storage } from "../firebase";
import moment from "moment";
import "moment/locale/es";

const myfunctions = {};
myfunctions.updateReports = (data, image, updatePercentage) => {
  // myfunctions.updateReports = (data, image, updatePercentage, geolocation) => {
  return new Promise((resolve, reject) => {
    if (!data) {
      reject("La data para la actualización no se encuentra");

      return;
    }

    if (!image) {
      reject("No se encuentra la foto");

      return;
    }

    if (!updatePercentage) {
      reject(
        "No se encuentra la función para actualizar el porcentaje de carga"
      );
      console.log(
        "No se encuentra la función para actualizar el porcentaje de carga"
      );

      return;
    }

    // if (!geolocation) {
    //   reject("No se encuentra la geolocalización");

    //   return;
    // }

    data.nameImage = `${moment(new Date()).format("DDMMYYYYhmmssa")}`;
    // data.geolocation = geolocation;
    data.createDate = new Date();

    const photoReference = storage
      .ref()
      .child("imageReport")
      .child(`${data.id}`)
      .child(data.nameImage);
    const task = photoReference.put(image);
    task.on(
      "state_changed",
      (snapshot) => {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        updatePercentage(progress);
      },
      (reason) => {
        console.log(reason);
        reject(reason);
      },
      () => {
        photoReference
          .getDownloadURL()
          .then((value) => {
            data.downloadURL = value;
            firestore
              .collection("assignments")
              .doc(`${data.id}`)
              .update({
                reports: updateFirebase.arrayUnion(data),
              })
              .then((value) => {
                resolve("HAS REPORTADO EXITOSAMENTE");
              })
              .catch((reason) => {
                console.log(reason);
                reject(reason);
              });
          })
          .catch((reason) => {
            console.log(reason);
            reject(reason);
          });
      }
    );
  });
};

export default myfunctions;
